export default __webpack_public_path__ + "6a3a8f34a4a08177e07c631ae2166618.svg";